import { render, staticRenderFns } from "./CarePairingTherapist.vue?vue&type=template&id=16bbbd0e&scoped=true&"
import script from "./CarePairingTherapist.vue?vue&type=script&lang=js&"
export * from "./CarePairingTherapist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bbbd0e",
  null
  
)

export default component.exports